



























require('axios')
import { Component, Prop, Vue } from 'vue-property-decorator';
import NewApi, { BasePath, ImagePath, ImageCoverPath } from '../ts/api';
import { DefaultApi, Image, Credentials, Galleries } from '../api';


let api: DefaultApi;

@Component(
  {
    components:{

    }
  }
)
export default class GalleryOverview extends Vue {
  galleries = [] as Galleries[];
  
  mounted(){
    api = NewApi()
    api.galleryGet().then(r => this.galleries = r.data.filter(g => g.studio_id && g.studio_id != 0)).catch(e => console.error("could not fetch images"))
  }
  getImageUrl(filename: string) {
    return ImageCoverPath(filename)
  }

  getLink(id :number){
    return "/galleries/detail?id="+id
  }

  getYear(){
    return new Date().getFullYear()
  }
}
